import { merchantIcons } from '@assets/icons';
import { memo } from 'react';

import BusinessDetailMetaRow from './BusinessDetailMetaRow';

const BusinessDetailMeta = memo(
  ({ category, isOpen, closingTime, rating, reviewCount, priceLevel, address }) => (
    <div className="flex w-full flex-col gap-business-results">
      {category ? (
        <BusinessDetailMetaRow icon={merchantIcons.tag}>{category}</BusinessDetailMetaRow>
      ) : null}

      <BusinessDetailMetaRow icon={merchantIcons.clock}>
        {isOpen ? (
          <>
            <span className="text-merchant-success">Open. </span>
            {closingTime ? <span>Closes {closingTime}</span> : <span>Open now</span>}
          </>
        ) : (
          <span>Closed</span>
        )}
      </BusinessDetailMetaRow>

      {(rating != null || reviewCount != null || priceLevel) && (
        <BusinessDetailMetaRow icon={merchantIcons.star}>
          {rating != null ? rating : '—'}
          {reviewCount != null ? ` (${reviewCount})` : ''}
          {priceLevel ? ` ${priceLevel}` : ''}
        </BusinessDetailMetaRow>
      )}

      {address ? (
        <BusinessDetailMetaRow icon={merchantIcons.location}>{address}</BusinessDetailMetaRow>
      ) : null}
    </div>
  ),
);

BusinessDetailMeta.displayName = 'BusinessDetailMeta';

export default BusinessDetailMeta;
